<script setup lang="ts">
const items = [
  'Sudah kirim broadcast, tapi pelanggan nggak respon.',
  'Chat follow-up manual makan waktu & tenaga.',
  'Repeat order cuma dari pelanggan lama — itu pun kadang lupa.',
  'Penjualan naik-turun, susah diprediksi.'
]
</script>

<template>
  <UiSectionWrapper
    image-class="lg:order-first"
    title="Capek Promosi Terus, Tapi Pelanggan Nggak Balik-Balik?"
    hero-image="/images/roms-banner-6.webp"
    :items="items"
    item-icon="material-symbols:cancel"
    class="py-12"
    :with-action="false"
  />
</template>
